// A new round's free time (billing stage 1, docs/plans/billing/PLAN.md; the price list of 12 Oct 2026 and the terms).
// One copy for the server (sign-up, the Rounds page) and the phone (the sign-up screens' "6 months free").
//
// standard   3 months: everyone, partner links (p-<code>) included ("A business you refer gets the usual 3 months")
// first-100  6 months: the First 100 link (?from=first-100 or first-100-<place>), while places are left
// referred   4 months: another round's referral link (ref-<code>, a code that exists; billing stage 7)
// tester    12 months: invited testers, marked by Liam on the Rounds page; never from a link (a guessable tag would
//                      give anyone a free year)
//
// The free time runs from the round's own day it signed up (businesses.free_from) and its last day is fixed then
// (businesses.trial_ends_on). Billing carries that day into Stripe and never starts the months again.

export type FreeOffer = 'standard' | 'first-100' | 'referred' | 'tester'
export const FREE_OFFERS: readonly FreeOffer[] = ['standard', 'first-100', 'referred', 'tester']

export const FREE_MONTHS: Record<FreeOffer, number> = { standard: 3, 'first-100': 6, referred: 4, tester: 12 }

export const FREE_OFFER_WORDS: Record<FreeOffer, string> = {
  standard: 'Standard',
  'first-100': 'First 100',
  referred: 'Referred',
  tester: 'Tester',
}

// The First 100: places go in sign-up order, one per round. Liam's own rounds take none (Dropby, his Enfield trial
// round and his Enfield round, by id). A place, once given, is the round's for good (businesses.first_100_place):
// marking it a tester and back never loses it (Astra, 12 Oct 2026), and it is still counted while it is a tester.
export const FIRST_100_PLACES = 100
export const LIAMS_OWN_ROUNDS: readonly number[] = [1, 2, 3]

// The places taken, one count for sign-up, the tester switch, GET /api/public/places and the Rounds page. Sign-up
// reads it inside its own INSERT, so two sign-ups at once can never both take the last place (Astra, 12 Oct 2026).
export const FIRST_100_TAKEN_SQL = `SELECT COUNT(*) FROM businesses WHERE first_100_place = 1 AND id NOT IN (${LIAMS_OWN_ROUNDS.join(', ')})`

// What the sign-up link's tag asks for. Whether a First 100 place is still free, and whether a referral code is real, is
// the server's to say (signup.ts).
export function offerFromTag(tag: string | null | undefined): FreeOffer {
  if (tag && /^first-100(-|$)/.test(tag)) return 'first-100'
  if (tag && /^ref-[a-z0-9]{10}$/.test(tag)) return 'referred'
  return 'standard'
}

// "3 months" / "6 months": the sign-up screens' words for the free time the link asks for.
export function freeMonthsWords(tag: string | null | undefined): string {
  return `${FREE_MONTHS[offerFromTag(tag)]} months`
}

// SQLite's date(free_from, '+N months'): the same day N months on (a day the month lacks runs into the next, as the
// three months always have).
export function monthsModifier(offer: FreeOffer): string {
  return `+${FREE_MONTHS[offer]} months`
}
